export default "__VITE_PUBLIC_ASSET__be8a87b3__"